import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { GrpMntDetailModalComponent } from '../grp-mnt-detail-modal/grp-mnt-detail-modal.component';
import { GrpMntRecipientModalComponent } from '../grp-mnt-recipient-modal/grp-mnt-recipient-modal.component';
import { GrpMntWebUserModalComponent } from '../grp-mnt-web-user-modal/grp-mnt-web-user-modal.component';
import { HelperService, DialogService, LanguageService, AuthService } from 'src/app/services';
import { ConstantsHelper } from 'src/assets/constants/constants.helper';
import { GroupMaintenanceService } from '../group-maintenance.service';
import { MatTabChangeEvent} from '@angular/material/tabs';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { of as observableOf, Subscription } from 'rxjs';
import { MediaObserver } from '@angular/flex-layout';
import { finalize, catchError } from 'rxjs/operators';
import * as _ from 'lodash';
 
@Component({
  selector: 'esc-group-maintenance-detail',
  templateUrl: './group-maintenance-detail.component.html',
  styleUrls: ['./group-maintenance-detail.component.scss']
})
export class GroupMaintenanceDetailComponent implements OnInit {
  @Input() detail;
  @Input() detailKeys = [];
  @Input() loading;
  @Input() type;
  @Input() moduleCode;
  @Output() edit = new EventEmitter;
  @Output() refresh = new EventEmitter;
  @Output() closeDetail = new EventEmitter;

  private listSub: Subscription;
  private tableData: any;
  selectedTabIndex = 0;
  webUsers = [];
  recipients = [];
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  public constants = ConstantsHelper;
 
  constructor(
    public helper: HelperService,
    public media: MediaObserver,
    public authService: AuthService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    private groupMntSvc: GroupMaintenanceService,
  ) { }
 
  public detailData;
 
  ngOnInit() {
    this.tableData = _.cloneDeep(INITIAL_OPTIONS);
    this.tableData.web_filter.group_filter_id = _.get(this.detailData, 'id');
  }

  ngOnDestroy() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
  }
 
  ngOnChanges(changes: SimpleChanges) {
    if(_.get(changes.detail, 'currentValue')) {
      this.detailData = _.clone(changes.detail.currentValue);
      this.selectedTabIndex = 0;
    }
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.selectedTabIndex = _.clone(tabChangeEvent.index);
    if(_.get(tabChangeEvent, 'index') == 1) {
      this.tableData.web_filter.group_filter_id = _.get(this.detailData, 'id');
      this.webUsers = [];
      this.getWebUsers();
    }
    if(_.get(tabChangeEvent, 'index') == 2) {
      this.tableData.web_filter.group_filter_id = _.get(this.detailData, 'id');
      this.recipients = [];
      this.getRecipients();
    }
  }

  getWebUsers() {
    let loadingDialog = this.dialogService.loading();
    this.loading.webUsers = true;
    this.listSub = this.groupMntSvc.getWebUsers(this.tableData).pipe(
      finalize(() => {
        loadingDialog.close();
        this.loading.webUsers = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.webUsers.length == 0) {
          this.loading.detailError = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.detailError = true;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.webUsers = this.webUsers.concat(res.data);
        }
      });
  }

  getRecipients() {
    let loadingDialog = this.dialogService.loading();
    this.loading.recipients = true;

    this.listSub = this.groupMntSvc.getRecipients(this.tableData).pipe(
      finalize(() => {
        loadingDialog.close();
        this.loading.recipients = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.recipients.length == 0) {
          this.loading.detailError = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.tableData.web_filter.offset -= this.tableData.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.detailError = true;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.recipients = this.recipients.concat(res.data);
        }
      });
  }

  upsertUserRecipient(data) {
    switch (this.selectedTabIndex) {
      case 1: {
        this.openWebUserModal(data);
        break;
      }
      case 2: {
        this.openRecipientModal(data);
        break;
      }
    }
  }

  updateGroup(mode) {
    let dialogRef: MatDialogRef<GrpMntDetailModalComponent>;
    dialogRef = this.dialogService.openDialog(GrpMntDetailModalComponent, {
      width: '50%',
      height: '60%',
      autoFocus: false,
      disableClose: false,
      data: _.get(this, 'detailData'),
    });
    dialogRef.afterClosed().subscribe((res) => {
      if(res) {
        console.log(res);
        this.detailData = _.cloneDeep(res);
        this.refresh.next(true);
      }
    })
  }

  openWebUserModal(data) {
    let dialogRef: MatDialogRef<GrpMntWebUserModalComponent>;
    data["group_filter_id"] = _.get(this.detailData, 'id');
    
    dialogRef = this.dialogService.openDialog(GrpMntWebUserModalComponent, {
      width: '40%',
      height: '40%',
      autoFocus: false,
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe((res) => {
      if(res) {
        this.refresh.next(true);
        this.selectedTabIndex = 0;
      }
    })
  }
  
  openRecipientModal(data) {
    let dialogRef: MatDialogRef<GrpMntRecipientModalComponent>;
    data["group_filter_id"] = _.get(this.detailData, 'id');

    dialogRef = this.dialogService.openDialog(GrpMntRecipientModalComponent, {
      width: '40%',
      height: '40%',
      autoFocus: false,
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe((res) => {
      if(res) {
        this.refresh.next(true);
        this.selectedTabIndex = 0;
      }
    })
  }

  close() {
    this.closeDetail.next(true);
  }
 
  modify() {
    this.edit.next(true);
  }
}
 
const INITIAL_OPTIONS = {
	web_filter: {
    group_filter_id: 0,           
    limit: 50,
    offset: 0,
    keyword: "",
    is_asc: 1,
    drop_down: 0,
  }
};